/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';

function useOutsideAlerter(ref, setShowDropDown) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowDropDown(false);
      }
    }
    // Bind the event listener
    document.addEventListener('click', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('click', handleClickOutside);
    };
  }, [ref, setShowDropDown]);
}


function GridMetricPicker(props) {
  const {
    metrics,
    newI18n,
    updateMetric,
  } = props;

  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(metrics[0]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const selectedMetricText = useMemo(() => newI18n.getString(selectedMetric.i18nKey), [selectedMetric.i18nKey]);

  const selectNewMetric = useCallback((metric) => {
    if (updateMetric) {
      updateMetric(metric.key);
    }
    setShowDropDown(false);
    setSelectedMetric(metric);
  }, [updateMetric]);


  const listItems = useMemo(() => metrics.map(metric => (
    <li className="menuitem" key={metric.key}>
      <a onClick={() => { selectNewMetric(metric); }}>
        {newI18n.getString(metric.i18nKey)}
      </a>
    </li>
  )), [metrics, newI18n, selectNewMetric]);


  const ref = useRef(null);
  useOutsideAlerter(ref, setShowDropDown);

  return (
    <div className="metric-container">
      <div className="btn-group btn btn-default metric-picker open">
        <div
          className="metric-picker__button metric-picker__button--single dropdown-toggle"
          ref={ref}
          onClick={() => { setShowDropDown(!showDropDown); }}
        >
          <div className="metric-picker__name">
            {selectedMetricText}
          </div>
          <span className="glyphicon glyphicon-triangle-bottom toolbar-icon pull-right" />
        </div>
        {showDropDown && <ul className="dropdown-menu dropdown-menu-right">{listItems}</ul>}
      </div>
    </div>
  );
}

GridMetricPicker.defaultProps = {
  updateMetric: undefined,
};
GridMetricPicker.propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    i18nKey: PropTypes.string.isRequired,
  })).isRequired,
  updateMetric: PropTypes.func,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

export default GridMetricPicker;
